module.exports = __webpack_public_path__ + "media/images/emblems/Sumiswald-coat_of_arms-e56918a7bdf4d9bb852e8d9bc73246bb.svg";